import { useEffect, useRef, useState } from 'react';

export enum TimerState {
  COMPLETED,
  STOPPED,
  RUNNING,
}

interface Props {
  minutes: number;
  seconds: number;
}
function useTimer({ minutes, seconds }: Props) {
  const timer = useRef<NodeJS.Timeout>();

  const [time, setTime] = useState({ mins: minutes, secs: seconds });

  const [timerState, setTimerState] = useState(TimerState.STOPPED);

  useEffect(() => {
    if (timerState === TimerState.RUNNING) {
      const t = setInterval(() => {
        setTime(prev => {
          if (prev.mins > 0 || prev.secs > 0) {
            if (prev.secs === 0) {
              return {
                mins: prev.mins - 1,
                secs: 59,
              };
            }

            return {
              mins: prev.mins,
              secs: prev.secs - 1,
            };
          }

          setTimerState(TimerState.COMPLETED);
          return prev;
        });
      }, 1000);

      timer.current = t;
    } else {
      clearInterval(timer.current);
      timer.current = undefined;

      setTime({ mins: minutes, secs: seconds });
    }
  }, [minutes, seconds, timerState]);

  const start = () => {
    setTimerState(TimerState.RUNNING);
  };

  const reset = () => {
    clearInterval(timer.current);
    timer.current = undefined;

    setTimerState(TimerState.STOPPED);
    setTime({ mins: minutes, secs: 0 });
  };

  return {
    timerState,
    time,
    start,
    reset,
  };
}

export default useTimer;
